<template>

  <div class="vflex">
    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Members') }}</h4>
        </div>
        <div class="btn-row">
          <div class="form-inline">
            <select
              class="form-control mr-2"
              @change="setStatus($event.target.value)">
              <option value="active">{{ $t('Active') }}</option>
              <option value="inactive">{{ $t('Inactive') }}</option>
              <option value="all">{{ $t('All') }}</option>
            </select>
            <input-keyword
              @input="setKeywords"
              :placeholder="$t('Search')"
              class="mr-2" />
            <button
              type="button"
              class="btn btn-primary"
              @click="showInviteModal()">
              + {{ $t('Invite new member') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">
      
      <Paginaty
        :total="paginate.total"
        :pages="paginate.pages"
        :page="paginate.page"
        :creating="creating"
        :loading="loading"
        @changePage="loadData">
        
        <template slot="content">
          <table class="table">
            <thead>
              <tr>
                <th width="40"></th>
                <th-sort
                  field="user_id.name"
                  :value="sort"
                  @input="setSort">{{ $t('Name') }}</th-sort>
                <th-sort
                  field="user_id.email"
                  :value="sort"
                  @input="setSort">{{ $t('Email') }}</th-sort>
                <th-sort
                  field="active"
                  :value="sort"
                  @input="setSort">{{ $t('Status') }}</th-sort>
                <th-sort
                  field="created_at"
                  :value="sort"
                  @input="setSort">{{ $t('Created at') }}</th-sort>
                <th-sort
                  field="role_id"
                  :value="sort"
                  @input="setSort">{{ $t('Role') }}</th-sort>
              </tr>
            </thead>
            <tbody>
              <MemberUserItem
                v-for="(member, index) in members"
                :key="index"
                :value="member"
                @deleted="loadData();" 
                @saved="loadData(paginate.page);" />
            </tbody>
          </table>
        </template>

        <template slot="noresults">
          {{ $t('There are no items') }}
        </template>

      </Paginaty>

      <MemberUserForm
        v-if="modal_select"
        :initMember="modal_select" 
        @hideModal="hideModal()" 
        @deleted="loadData(); hideModal()" 
        @saved="loadData(paginate.page); hideModal()" />
      <MemberInviteForm
        v-if="modal_invite"
        :initMemberInvite="modal_invite" 
        @hideModal="hideInviteModal()"
        @saved="refreshMemberInvite()" />

    </div>

  </div>

</template>

<script>
import InputKeyword from '@/components/Fields/InputKeyword'
import ThSort from '@/components/Parts/ThSort'
import Paginaty from '@/components/Paginaty/Paginaty'
import MemberUserForm from './MemberUserForm'
import MemberUserItem from './MemberUserItem'
import MemberInviteForm from './MemberInviteForm'

export default {
  name: 'Member',
  components: {
    ThSort,
    InputKeyword,
    Paginaty,
    MemberUserForm,
    MemberUserItem,
    MemberInviteForm
  },
  data () {
    return {
      creating: true,
      loading: true,
      modal_select: false,
      modal_invite: false,
      filters: {
        active: true
      },
      sort: 'user_id.name'
    }
  },
  computed: {
    members () {
      return this.$store.getters.getMembers
    },
    paginate () {
      return this.$store.getters.getMembersPaginate
    },
    currentRoute () {
      return this.$route.path
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /* loadData  */
    loadData (page) {
      this.loading = true

      const params = {
        ...this.filters,
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectMembers', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
      })
    },
    /* refreshMemberInvite  */
    refreshMemberInvite () {
      this.$store.dispatch('selectMemberInvites', {})
    },
    /* modal  */
    showCreateModal () {
      this.modal_select = {}
    },
    hideModal () {
      this.modal_select = false
    },
    /* modal  */
    showInviteModal () {
      this.modal_invite = {}
    },
    hideInviteModal () {
      this.modal_invite = false
    },
    /* filters  */
    setKeywords (keywords) {
      this.filters = {
        ...this.filters,
        q: keywords ? '~' + keywords : undefined
      }

      this.loadData(1)
    },
    setStatus (status) {
      const active = {
        active: true,
        inactive: false,
        all: undefined
      }[status]

      this.filters = {
        ...this.filters,
        active: active
      }

      this.loadData(1)
    },
    setSort (sort) {
      this.sort = sort
      this.loadData(1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.photo {
  width: 30px;
  height: 30px;
  border-radius: 15px;
  margin: -20px 0; 
}
</style>



// WEBPACK FOOTER //
// src/components/Member/MemberUser.vue